import React, { useState, useEffect, useRef } from 'react'
import "../assets/css/ZoneMaster.css";
import "../assets/css/global.css";
import FooterButton from './FooterButton'
import { getAreaDetails, bulkAreaDelete, plantDetail, getAreaZone } from "../utils/apiServices"
import DataNotFound from './DataNotFound'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { createCoords, zoneDetailsMap } from '../constants/MapContainer'
import { SuccessModal, WarningModal } from './FormComponents';
import { AUTH_CODE, path_Operation } from '../constants/constVariables'
import BackButton from '../clientComponents/BackButton/BackButton'
import { CustomTab } from '../atomicComponents'
import { useAuthorizationContext } from '../providers/AuthorizationHandler/AuthorizationHandler'
import FormModal from './FormComponents/FormModal'
import { postUsageAnalyticsCall } from '../constants/Utils'

const PlantDetails = () => {
    const { user } = useAuthorizationContext();
    const location = useLocation();
    const [plantData, setplantData] = useState([]);
    const [isModalOpen, setModalIsOpen] = useState(false);
    const [errorMessage, seterrorMessages] = useState("");
    const [isErrorModalOpen, setErrorModalIsOpen] = useState(false);
    const buttonDisplay = useRef(null);
    const [isWarningModalOpen, setWarningModalIsOpen] = useState(false);
    const [pageLeaveTime, setPageLeaveTime] = useState();

    useEffect(() => {
        if (window.matchMedia('(max-width:768px)').matches) {
            buttonDisplay.current.style.display = "none";
        } else {
            buttonDisplay.current.style.display = "flex";
        }
        setPageLeaveTime(new Date())
    }, []);

    const getData = async () => {
        const data = location.state.data;
        // console.log("data = ",data)
        const response = await plantDetail(data.plant_id);
        const response2 = await getAreaZone(data.plant_id);
        // console.log("dataaa = ", response.data.data[0], response2.data.data)
        setplantData(response.data.data[0])
        createCoords(
            response.data.data[0].plant_coordinates[0],
            response.data.data[0].zoom,
            response2.data.data.area_data,
            response2.data.data.zone_data,
            false,
            false,
            false,
            "Plant",
            false,
            false,
            response?.data?.data[0],
            false
        )
    }
    useEffect(() => { getData() }, [''])
    useEffect(() => {
        return () => {
            if (new Date() - pageLeaveTime) {
                const a = path_Operation?.filter((d, i) => {
                    return d?.name == location?.pathname
                })
                postUsageAnalyticsCall(user?.name, user?.userID, a[0]?.pageName ? a[0]?.pageName : location?.pathname, pageLeaveTime, a[0]?.operation ? a[0]?.operation : 'view', (new Date() - pageLeaveTime))
            }
        }
    }, [pageLeaveTime])
    const toggleWarningModal = () => {
        setWarningModalIsOpen(!isWarningModalOpen);
    };
    const toggleModal = () => {
        if (!isErrorModalOpen)
            navigate("/area-master");
        setErrorModalIsOpen(false);
    };
    const browserBack = () => {
        navigate(-1);
    }
    const navigate = useNavigate();
    const handleButton = (val) => {
        if (val == "delete") {
            toggleWarningModal();
        }
    }

    const deleteData = async (data) => {
        var deleteJsonpayload = {};
        deleteJsonpayload = { id: [data.area_id], updated_by: user.name, updated_by_id: user.userID };
        const response = await bulkAreaDelete(deleteJsonpayload).then(response => {
            setModalIsOpen(true);
            const a = path_Operation?.filter((d, i) => {
                return d?.name == "delete-area"
            })
            postUsageAnalyticsCall(user?.name, user?.userID, a[0]?.pageName ? a[0]?.pageName : "delete-area", new Date(), a[0]?.operation ? a[0]?.operation : 'view', 0)
        })
            .catch(error => {
                var errorMessagePayload = {
                    totalData: error.response.data.total_count,
                    failedData: error.response.data.fail_to_delete_count,
                    errorMessageData: []
                };
                error.response.data.data.forEach((element) => {
                    errorMessagePayload.errorMessageData.push(element);
                });
                seterrorMessages(errorMessagePayload);
                setErrorModalIsOpen(true);
            });
    }
    return (
        <>
            {
                plantData ?
                    <>
                        {/* <Breadcrumb /> */}
                        <div className='breadcrumb'>
                            <BackButton basePath={"Plant Geofence"} action={"plant details"} handleClick={browserBack} />
                        </div>
                        <div className="headerwithcount">
                            <div className='countdiv'>
                                <CustomTab
                                    withOutCount
                                    isSelected={false}
                                    title={"Plant Details"}
                                />
                            </div>
                            <div className="blankdiv" />
                        </div>
                        {/* <Header name="Area Details" search={false} filter={false} /> */}
                        <div className="vin-details-container">
                            <div className="zone-details-main-container">
                                <div className="vin-details-header mediumFont">Plant Details</div>
                                <div className="zone-detail-container">
                                    <div className="zone-detail-inner-container">
                                        <div className="zone-header-data-container">
                                            <span className="zone-header">Plant Name</span>
                                            <span className="zone-data smallFont">{plantData.plant_name}</span>
                                        </div>

                                        <div className="zone-header-data-container">
                                            <span className="zone-header">Plant ID</span>
                                            <span className="zone-data smallFont">{plantData.plant_ids}</span>
                                        </div>
                                        <div className="zone-header-data-container">
                                            <span className="zone-header">Category</span>
                                            <span className="zone-data smallFont">{plantData.plant_category}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="zone-map-container" id="map_container"></div>
                        </div>
                        <div className="horizontal-line" style={{ marginTop: "1rem" }}></div>
                        <div className="vin-details-footer">
                            <div className='download-filter-btn-container' ref={buttonDisplay} style={{ display: 'flex', justifyContent: "space-between" }}>
                                {/* <FooterButton shouldEnable={false} value="delete" backgroundColor="#F17C7C" secondaryColor="#c83f49" handle={handleButton} authOperation={AUTH_CODE.DELETE} /> */}
                                <Link state={{ edit: true, data: plantData }} to="/plant-master/edit-plant" exact> <FooterButton shouldEnable={false} value="edit" backgroundColor="#82C1A7" secondaryColor="#488f71" handle={handleButton} authOperation={AUTH_CODE.EDIT} /></Link>
                            </div>
                            <FooterButton shouldEnable={true} value="BACK" handle={browserBack} secondaryColor="#488f71" backgroundColor="#82C1A7" />
                        </div>
                        {isWarningModalOpen && (<WarningModal open={isWarningModalOpen} handleClose={() => toggleWarningModal()} confirmDelete={() => deleteData(plantData)} />)}
                        {isModalOpen && <SuccessModal open={isModalOpen}
                            handleClose={() => toggleModal()}
                            title={"Area deleted successfully"} />}
                        {isErrorModalOpen && <FormModal open={isErrorModalOpen} handleClose={() => toggleModal()} title={errorMessage} />}
                    </>
                    :
                    <DataNotFound />
            }
            <style jsx="true">
                {`
                a {
                    text-decoration: none;
                    color: inherit;
                  }
            .footer-button {
                align-items: center;
                border: none;
                border-radius: 4px;
                box-shadow: 0 3px 3px rgb(0 0 67 / 13%);
                color: #fff;
                cursor: pointer;
                display: flex;
                font-weight: 700;
                line-height: 19px;
                padding: 0.5rem 2rem;
                text-align: center;
                text-transform: uppercase;
                white-space: nowrap;
            }
          /* Dont move it to any css file, keep it here only */
          .vin-search-head-container {
            text-transform: unset;
            color: #F17C7C;
            font-size: var(--smallFontSize);
            font-weight: 400;
            padding: 16px;
            // margin: 0 auto;
            // width: fit-content;
          }
          @media only screen and (max-width: 768px) {
            .vin-search-head-container {
                padding:16px;
              }

            .navbar {
              display: none;
            }
            
            .mob-secondary-navbar {
              width: calc(100% - 2rem);
              position: fixed;
              left: 0;
              top: 0;
            }
            .mob-secondary-header {
              display: flex;
              background: #f3f5f9;
              align-items: center;
              justify-content: space-between;
              padding: 0.25rem 1rem;
              font-weight: 600;
              line-height: 19px;
              color: #707070;
            }
            .mob-header-heading {
              display: flex;
              align-items: center;
            }
            .mob-header-heading img {
              height: 20px;
              margin-right: 0.5rem;
            }
          }
        `}
            </style>
        </>

    )
}

export default PlantDetails